import React from 'react'
import { motion } from 'framer-motion'

const DURATION = 0.25
const STAGGER = 0.025

const FlipLink = ({ children }) => {
  const text = String(children) // Ensure 'text' is a string

  return (
    <motion.div
      initial="initial"
      whileHover="hovered"
      className="relative block overflow-hidden whitespace-nowrap uppercase "
    >
      <div>
        {text.split('').map((l, i) => (
          <motion.span
            key={i}
            variants={{
              initial: { y: 0 },
              hovered: { y: '-100%' },
            }}
            transition={{
              duration: DURATION,
              ease: 'easeInOut',
              delay: STAGGER * i,
            }}
            className="inline-block "
          >
            {l}
          </motion.span>
        ))}
      </div>
      <div className="absolute inset-0 ">
        {text.split('').map((l, i) => (
          <motion.span
            key={i}
            variants={{
              initial: { y: '100%' },
              hovered: { y: 0 },
            }}
            transition={{
              duration: DURATION,
              ease: 'easeInOut',
              delay: STAGGER * i,
            }}
            className="inline-block "
          >
            {l}
          </motion.span>
        ))}
      </div>
    </motion.div>
  )
}

export default FlipLink
